export default __webpack_public_path__ + "static/media/search-icon.f4287052.svg";